import axios from 'axios'
import { axiosInstanceNestingale } from '../axios'
const fetchRoomTypes = async () => {
    const response = await axios.get('https://nestingale.com/v1/api/roomTypes')
    return response.data
}
export default fetchRoomTypes